import PropTypes from 'prop-types';
import React from 'react';

import LightButton from '../atoms/LightButton';

class CloseButton extends React.Component {
  static get propTypes() {
    return {
      onClick: PropTypes.func,
    };
  }

  render() {
    return <LightButton onClick={this.props.onClick}>閉じる</LightButton>;
  }
}

export default CloseButton;
